import { render, staticRenderFns } from "./AddGrnProduct.vue?vue&type=template&id=68f0f496&scoped=true&"
import script from "./AddGrnProduct.vue?vue&type=script&lang=js&"
export * from "./AddGrnProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddGrnProduct.vue?vue&type=style&index=0&id=68f0f496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0f496",
  null
  
)

export default component.exports